export default __webpack_public_path__ + "static/media/r-inscri2.97346f87.png";